import zeplinColor from 'theme/Color';
import { Relationship } from './types';

interface RelationshipStyle {
  backgroundColor: string;
  color: string;
}

export const relationshipColorMap: Record<Relationship, RelationshipStyle> = {
  'My Contact': {
    backgroundColor: zeplinColor.Success,
    color: zeplinColor.Neutral1,
  },
  'Our Contact': {
    backgroundColor: zeplinColor.Blue,
    color: zeplinColor.Neutral1,
  },
  Known: {
    backgroundColor: zeplinColor.Neutral4,
    color: zeplinColor.BasicBlack,
  },
};
